import templateUrl from 'emun.salesrep/salesrep-container-full.html'
import basicController from 'servicestack/basic.controller.properties'
import resolve from 'ioc/resolve'
import AutoQuery from 'servicestack/auto-query/auto-query'
import salesrepConfig from 'emun.salesrep/salesrep.config'

class SalesRepContainerController {
  constructor() {
    const $ctrl = this;
    basicController($ctrl);
    $ctrl.ytdSales = {
      total: 0,
      count: 0
    };
    let options = {
      url: 'QuerySalesReps.json?Active=1',
      pageSize: 15,
      criteria: {},
      filters: [
        //{ date: 'StartedOn', title: 'Start Date' },
        //{ date: 'TerminatedOn', title: 'End Date' },
        { groupBy: 'City', maxHeight: 200, collapsed: true },
        { groupBy: 'State', maxHeight: 200, collapsed: true },
        { groupBy: 'Zip', maxHeight: 200, collapsed: true },
        //{ groupBy: 'TerritoryName', title: 'Territory' },
        //{ groupBy: 'RegionName', title: 'Region' },
        //{ groupBy: 'DivisionId', title: 'Division' },
      ],
      hideLeftNav: true, // $ctrl.$pageConfig.is('gt-sm'),
      orderBy: 'Name',
      autoLoad: true,
      append: false,
      sortOptions: {
        'Id': 'Id: Low to High',
                '-Id': 'Id: High to Low',
        'Name': 'Name: A to Z',
        '-Name': 'Name: Z to A',
        'State': 'State: A to Z',
        '-State': 'State: Z to A',
        'Zip': 'Zip: 1 to 9',
        '-Zip': 'Zip: 9 to 1',
      }
    };
    if (!salesrepConfig.includeInactive) options.criteria.Active = 1;
    $ctrl.query = new AutoQuery(options);
  }
  load() {
    return this.query.load.apply(this.query, arguments);
  }
  viewRep(rep) {
    this.$state.transitionTo("salesrep.dashboard", { repId: rep.id });
  }
}

let SalesRepContainer = {
  controller: SalesRepContainerController,
  templateUrl($element, $attrs) {
    return $attrs.templateUrl || templateUrl;
  }
}

export default SalesRepContainer